import Vue from "vue";
import axios from "axios";

const state = () => ({});

const getters = {};

const actions = {
  createEpisode({ dispatch }, episode) {
    const result = axios.post(
      `${Vue.prototype.$config.apiUrl}/episode`,
      episode
    );
    return result.then(() => {
      dispatch("series/refreshSelectedSerie", null, { root: true });
      return result;
    });
  },
  updateEpisode({ dispatch }, episode) {
    const result = axios.put(
      `${Vue.prototype.$config.apiUrl}/episode`,
      episode
    );
    return result.then(() => {
      dispatch("series/refreshSelectedSerie", null, { root: true });
      return result;
    });
  },
  deleteEpisode({ dispatch }, episodeId) {
    const result = axios.delete(
      `${Vue.prototype.$config.apiUrl}/episode/${episodeId}`
    );
    return result.then(() => {
      dispatch("series/refreshSelectedSerie", null, { root: true });
      return result;
    });
  },
};

const mutations = {};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
